<div class="pt-3"></div>
<div class="row tab-container pl-2">
  <!-- Implemeting tabs  1st tabs-->
  <div class="col-2 tab-label externel-links tab-height p-2 ">
    <div class="lbl-text align-tabs" [ngClass]="{'activeTimeLine': toggleStatus === 'subTaskDetails'}">
      <a (click)="toggleMode('subTaskDetails')"> Task Details</a>
    </div>
  </div>
  <!-- 2nd tab -->
  <div class="col-2 tab-label externel-links tab-height p-2">
    <div class="lbl-text align-tabs drafttext" [ngClass]="{'activeTimeLine': toggleStatus === 'externalLinks'}">
        <a (click)="toggleMode('externalLinks')"> External Links</a>
    </div>
  </div>
</div>

<div *ngIf="toggleStatus === 'externalLinks'" class="pt-2">
  <lib-external-links
    [inputData]="{ fromBenProfile: false, fromTask: true, subTaskType: taskId }"
  ></lib-external-links>
</div>
<div *ngIf="toggleStatus === 'subTaskDetails'" class="pt-2">
<!-- <img src="../../../../../assets/images/petition_icon.png" height="50" width="40">
<h4 class="text-primary ml-2 d-inline">RFE 123</h4> -->
<p-accordion [activeIndex]="index">
  <p-accordionTab>
    <ng-template pTemplate="header">
      <img src="../../../../../assets/images/RFE_icon.png" height="50" width="40">
      <h4 class="text-primary ml-2 d-inline">RFE</h4>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="border-bottom p-py-3 p-px-3 subTaskDetailsHeader">
        <div class="row">
          <div class="col-11">
            <h5>Sub Task Details</h5>
          </div>
          <div class="col"> <button type="button" pButton icon="fa fa-chevron-up" (click)="closePanel()"></button></div>

        </div>

      </div>
      <div class="p-grid p-py-3 p-px-3">

        <form [formGroup]="rfeTabForm" class="p-col-12">

          <app-rfe-task [parentFormGroup]="rfeTabForm"></app-rfe-task>

          <div class="p-grid dashed-line p-my-4"></div>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-col-2">
              <button pButton type="submit" label="Save" [disabled]="!rfeTabForm?.valid" (click)="saveTask()"></button>
            </div>
            <div class="p-col-2">
              <button pButton type="button" class="p-button-secondary" label="Cancel" (click)="closePanel()"></button>
            </div>
          </div>

        </form>

      </div>
    </ng-template>

  </p-accordionTab>
</p-accordion>


<div *ngIf="stepsData && stepsData.length > 0" >
  <hr />
  <app-timeline [loadingFromOnChanges]="true" [selectedTaskType]="taskType" [taskObj]="stepsData" [taskId]="taskId"
    [taskTypeDetails]="taskTypeDetails" [selectedTaskType]="taskType" [isOutsideImagility]="isOutsideImagility"
    [petitionId]="petitionId" [userName]="userName" [noticeNumber]="noticeNumber"></app-timeline>
</div>
</div>
